import { render, staticRenderFns } from "./AppLeftRightArrows.vue?vue&type=template&id=8991abb6&scoped=true"
import script from "./AppLeftRightArrows.vue?vue&type=script&lang=js"
export * from "./AppLeftRightArrows.vue?vue&type=script&lang=js"
import style0 from "./AppLeftRightArrows.vue?vue&type=style&index=0&id=8991abb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8991abb6",
  null
  
)

export default component.exports